import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useValidateToken = (token: string): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  return useQuery(ReactQueryKeys.InviteToken, async () => {
    const response = await treasureApi().get(
      `/users/validate-token/?token=${token}`,
    );

    return response.data;
  });
};
